/*
 * @Description: 网站配置
 * @Author: youme
 * @LastEditors: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @Date: 2020-06-12 13:35:34
 * @LastEditTime: 2024-05-31 15:59:30
 */
import HSMOM from '@/assets/bannerlogo/HSMOM.png'
import HSMES from '@/assets/bannerlogo/HSMES.png'
import HSWMS from '@/assets/bannerlogo/HSWMS.png'
import HSEMS from '@/assets/bannerlogo/HSEMS.png'
import HSQMS from '@/assets/bannerlogo/HSQMS.png'
import HSEAM from '@/assets/bannerlogo/HSEAM.png'
const menus = [
  {
    name: '产品概述',
    skewing: 0,
    level: 3,
    children: [
      {
        name: 'HAOSMART体系',
        children: [
          {
            name: 'HSMOM',
            url: '/product-mom',
            iconUrl: HSMOM
          },
          {
            name: 'HSMES',
            url: '/product-mes',
            iconUrl: HSMES
          },
          {
            name: 'HSWMS',
            url: '/product-wms',
            iconUrl: HSWMS
          },
          {
            name: 'HSEMS',
            url: '/product-ems',
            iconUrl: HSEMS
          },
          {
            name: 'HSQMS',
            url: '/product-qms',
            iconUrl: HSQMS
          },
          {
            name: 'HSEAM',
            url: '/product-eam',
            iconUrl: HSEAM
          }
        ]
      },
      {
        name: 'HAOSMART价值',
        children: [
          {
            name: 'HSMOM',
            url: '/companyvalue',
            iconUrl: HSMOM
          },
          {
            name: 'HSMES',
            url: '/companyvalue',
            iconUrl: HSMES
          },
          {
            name: 'HSWMS',
            url: '/companyvalue',
            iconUrl: HSWMS
          },
          {
            name: 'HSEMS',
            url: '/companyvalue',
            iconUrl: HSEMS
          },
          {
            name: 'HSQMS',
            url: '/companyvalue',
            iconUrl: HSQMS
          },
          {
            name: 'HSEAM',
            url: '/companyvalue',
            iconUrl: HSEAM
          }
        ]
      }
    ]
  },
  {
    name: '解决方案',
    skewing: 104,
    column: true,
    level: 2
    // children: [
    //   {
    //     name: '电机',
    //     url: '/solution-case-del/1'
    //   },
    //   {
    //     name: '动力总成',
    //     url: '/solution-case-del/2'
    //   },
    //   {
    //     name: '锂电池',
    //     url: '/solution-case-del/3'
    //   },
    //   {
    //     name: '零件机加工',
    //     url: '/solution-case-del/4'
    //   },
    //   {
    //     name: '汽车零部件',
    //     url: '/solution-case-del/5'
    //   },
    //   {
    //     name: '汽车四大车间',
    //     url: '/solution-case-del/6'
    //   }
    // ]
  },
  {
    name: '客户案例',
    skewing: 208,
    column: true,
    level: 2,
    children: [
      {
        name: '变速箱',
        url: '/customercase-detail/3'
      },
      {
        name: '发动机',
        url: '/customercase-detail/5'
      },
      {
        name: '新能源',
        url: '/customercase-detail/2'
      },
      {
        name: '机加厂',
        url: '/customercase-detail/7'
      },
      {
        name: '配电柜',
        url: '/customercase-detail/6'
      }
    ]
  },
  {
    name: '关于智源',
    skewing: 312,
    column: true,
    level: 2,
    children: [
      {
        name: '豪森智源',
        url: '/company-profile'
      },
      {
        name: '智源荣誉',
        url: '/company-honor'
      },
      {
        name: '公司新闻',
        url: '/company-news'
      },
      {
        name: '智源优势',
        url: '/ouradvantage'
      },
      {
        name: '加入智源',
        url: '/recruit'
      }
    ]
  },
  {
    name: '联系我们',
    skewing: 416,
    column: false,
    level: 1,
    url: '/contact'
  }
]

const links = [
  { text: '产品概述', index: 0, includeLinks: ['/product-mom', '/product-mes', '/product-wms', '/product-ems', '/companyvalue'] },
  { text: '解决方案', index: 1, includeLinks: ['/solution-case-del/1'] },
  { text: '客户案例', index: 2, includeLinks: ['/customercase', '/customercase-detail/3', '/customercase-detail/5', '/customercase-detail/6', '/customercase-detail/7', '/customercase-detail/2'] },
  { text: '关于智源', index: 3, includeLinks: ['/company-profile', '/company-news', '/ouradvantage', '/recruit'] }
]

export {
  menus,
  links
}
